import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router';
import { getAllRigOperationTemplates } from 'src/store/entities/company-settings/company-settings';
import { Templates } from 'views/settings/templates/templates';
import { settingEntity } from 'src/enums/settings';
import { withErrorBoundary } from '@oliasoft-open-source/react-ui-library';
import { getCompanyTemplates } from 'src/store/entities/templates/templates';
import { selectCompanyTemplates, selectIsFetchingTemplates } from 'src/store/entities/templates/selectors';

const CompanyTemplates = ({ templates, getAllRigOperationTemplates, getCompanyTemplates }) => {
  const { company: companyId } = useParams();

  useEffect(() => {
    getCompanyTemplates(companyId);
    getAllRigOperationTemplates();
  }, []);

  return <Templates templates={templates} entity={settingEntity.COMPANY} />;
};

const mapStateToProps = (state) => {
  const templates = selectCompanyTemplates(state);
  const isFetching = selectIsFetchingTemplates(state);
  return {
    templates,
    isFetching,
  };
};

const mapDispatchToProps = {
  getAllRigOperationTemplates,
  getCompanyTemplates,
};

const Container = withErrorBoundary(connect(mapStateToProps, mapDispatchToProps)(CompanyTemplates));

export { Container as CompanyTemplates };
